module.exports = __webpack_public_path__ + "static/img/btn_google_light_normal.9c213055.svg";